import React from 'react';

import FolderSelector, {DEFAULT_PROJECT_FOLDER_LABEL_TEXT} from 'file-browser/FolderSelector';
import {ButtonSize} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LABEL_STYLES} from 'ui-library/inputs/InputConstants';
import {GenericEvent, Optional} from 'util/Types';

export default function ProjectFolderField({
  folderId,
  labelStyle,
  onChange,
  isRequired,
  buttonSize = ButtonSize.MEDIUM,
}: {
  folderId: Optional<string>;
  labelStyle: (typeof LABEL_STYLES)[keyof typeof LABEL_STYLES];
  onChange: (e: GenericEvent) => void;
  isRequired: boolean;
  buttonSize?: ButtonSize;
}): JSX.Element {
  const allowNone = !isRequired;
  return (
    <div>
      <FieldLabel label={DEFAULT_PROJECT_FOLDER_LABEL_TEXT} labelStyle={labelStyle} isRequired={isRequired} />
      <FolderSelector
        buttonSize={buttonSize}
        enableRedesign={true}
        allowNone={allowNone}
        noFolderText={allowNone ? 'None' : undefined}
        value={folderId}
        onChange={onChange}
        showInventory={true}
        showRegistries={false}
        unsetOnFetchFail={true}
      />
    </div>
  );
}
